import firebase from "firebase/app";
import "firebase/firestore";
import { atom, useRecoilValue } from "recoil";
import type { Viewer, WithId } from "@kaigi100-next/typing";
import { viewerConverter } from "lib/firebase/converters/viewer";
export const currentViewerState = atom<WithId<Viewer>>({
  key: "currentViewer",
  default: undefined,
});
export const userIdTokenState = atom<string>({
  key: "userIdTokenState",
  default: undefined,
});
export const firebaseAuthState = atom<firebase.User>({
  key: "firebaseAuthState",
  default: undefined,
  dangerouslyAllowMutability: true,
});

export const authLoadingState = atom<boolean>({
  key: "authLoading",
  default: true,
});

export function useCurrentViewer() {
  const loading = useRecoilValue(authLoadingState);
  const currentViewer = useRecoilValue(currentViewerState);
  const auth = useRecoilValue(firebaseAuthState);
  const userIdToken = useRecoilValue(userIdTokenState);
  const isStreamer = currentViewer ? currentViewer.streamSessionId !== "" : false;
  const reference =
    currentViewer &&
    firebase
      .firestore()
      .doc(`user/v1/viewers/${currentViewer.id}`)
      .withConverter(viewerConverter);
  return { loading, userIdToken, currentViewer, auth, reference, isStreamer };
}
